module.exports = __webpack_public_path__ + "static/img/hpds.ed595ee.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/activity/hpds.jpeg
// module id = DHvD
// module chunks = 1